document.addEventListener('DOMContentLoaded', function() {
    const navigator_element = document.getElementById('content-navigator');
    if (!navigator_element) return;

    const content_navigator = {
        data: window.acf_content_data,
        current_path: [],

        init() {
            this.render_level(this.data, []);
            this.setup_buttons();
        },

        render_level(items, path) {
            this.current_path = path;
            this.update_buttons();

            const content_area = document.querySelector('.content-area');
            const new_content = document.createElement('div');
            new_content.className = 'content-slide slide-right';

            if (this.has_options(items)) {
                new_content.innerHTML = this.render_options(items);
            } else {
                new_content.innerHTML = this.render_content(items);
            }

            content_area.appendChild(new_content);

            // Measure new content height and adjust container
            const new_height = new_content.scrollHeight;
            content_area.style.height = new_height + 'px';

            // Trigger animation
            setTimeout(() => {
                const current = content_area.querySelector('.slide-center');
                if (current) current.className = 'content-slide slide-left';
                new_content.className = 'content-slide slide-center';
            }, 10);

            // Clean up old slides
            setTimeout(() => {
                const old_slides = content_area.querySelectorAll('.slide-left');
                old_slides.forEach(slide => slide.remove());
            }, 300);

            // Update next button state after rendering
            setTimeout(() => {
                if (this.has_options(items)) {
                    this.update_next_button();
                } else {
                    // Hide next button when showing content (final step)
                    const next_btn = document.getElementById('next-btn');
                    next_btn.classList.add('d-none');
                }
            }, 50);
        },

        has_options(items) {
            if (!Array.isArray(items)) return false;
            return items.some(item => item && item.child_type === 'option');
        },

        render_options(items) {
            if (!Array.isArray(items)) return '<p>No options available</p>';

            let html = '';

            // Only show section title on top level (empty path) or if explicitly set
            if (this.current_path.length === 0) {
                html += '<h2 class="h4 mb-3">Tell us your concern</h2>';
            } else {
                // Look for section_title in current items
                const first_item = items.find(item => item && item.section_title);
                if (first_item && first_item.section_title) {
                    html += `<h2 class="h4 mb-3">${first_item.section_title}</h2>`;
                }
            }

            html += '<div class="row g-3"><div class="col"><div class="radios">';

            items.forEach((item, index) => {
                if (item && item.child_type === 'option' && item.label) {
                    html += `
            <div class="form-check box p-3 mb-3">
                <div class="radio ms-4">
                    <input class="form-check-input" type="radio" name="option" id="option-${index}" data-index="${index}">
                    <label class="form-check-label fw-bold" for="option-${index}">
                        ${item.label}
                    </label>
                </div>
            </div>`;
                }
            });
            html += '</div></div></div>';
            return html;
        },

        render_content(items) {
            if (!Array.isArray(items)) return '<p>No content available</p>';

            let html = '';

            // Check if we need to show a section title for content
            if (this.current_path.length > 0) {
                // Get the parent item that led to this content
                const parent_path = this.current_path.slice(0, -1);
                const parent_items = this.get_items_at_path(parent_path);
                const selected_parent_index = this.current_path[this.current_path.length - 1];
                const parent_item = parent_items[selected_parent_index];

                if (parent_item && parent_item.section_title) {
                    html += `<h3 class="h4 mb-3">${parent_item.section_title}</h3>`;
                }
            }

            let has_content = false;
            items.forEach(item => {
                if (item && item.content) {
                    if (item.child_type === 'content') {
                        html += `<div class="content mb-3">${item.content}</div>`;
                    }
                    else if (item.child_type === 'highlight_content') {
                        html += `<div class="content highlight p-3 rounded mb-3">${item.content}</div>`;
                    }
                    has_content = true;
                }
            });

            return has_content ? html : '<p>No content available</p>';
        },

        show_empty_message() {
            const content_area = document.querySelector('.content-area');
            const message = document.createElement('div');
            message.className = 'alert alert-info';
            message.textContent = 'This option has no content available.';
            content_area.appendChild(message);

            setTimeout(() => message.remove(), 3000);
        },

        get_selected_option() {
            const selected_radio = document.querySelector('input[name="option"]:checked');
            return selected_radio ? parseInt(selected_radio.dataset.index) : null;
        },

        navigate_next() {
            const selected_index = this.get_selected_option();

            if (selected_index === null) {
                this.show_selection_message();
                return;
            }

            const current_items = this.get_current_items();
            const selected_item = current_items[selected_index];

            if (!selected_item) return;

            const children = this.get_valid_children(selected_item);

            if (children && children.length > 0) {
                // Pass the section_title from the selected item to its children
                if (selected_item.section_title) {
                    children.forEach(child => {
                        if (!child.section_title) {
                            child.section_title = selected_item.section_title;
                        }
                    });
                }

                const new_path = [...this.current_path, selected_index];
                this.render_level(children, new_path);
            } else {
                console.log('Option has no content or children');
                this.show_empty_message();
            }
        },

        show_selection_message() {
            const content_area = document.querySelector('.content-area');
            const message = document.createElement('div');
            message.className = 'alert alert-warning';
            message.textContent = 'Please select an option first.';
            content_area.appendChild(message);

            setTimeout(() => message.remove(), 3000);
        },

        update_next_button() {
            const next_btn = document.getElementById('next-btn');
            const current_items = this.get_current_items();

            // Show next button only if we're showing options
            if (this.has_options(current_items)) {
                const selected_option = this.get_selected_option();

                if (selected_option !== null) {
                    // Check if selected option has valid children
                    const selected_item = current_items[selected_option];
                    const has_children = this.get_valid_children(selected_item) !== null;

                    next_btn.classList.remove('d-none');
                    next_btn.disabled = !has_children; // Disable if no children, enable if has children
                } else {
                    next_btn.classList.remove('d-none');
                    next_btn.disabled = true;
                }
            } else {
                next_btn.classList.add('d-none');
            }
        },

        get_valid_children(item) {
            if (!item.children) return null;
            if (item.children === false) return null;
            if (!Array.isArray(item.children)) return null;
            if (item.children.length === 0) return null;

            return item.children;
        },

        go_back() {
            if (this.current_path.length > 0) {
                const new_path = this.current_path.slice(0, -1);
                const items = this.get_items_at_path(new_path);
                this.render_level(items, new_path);
            }
        },

        get_current_items() {
            return this.get_items_at_path(this.current_path);
        },

        get_items_at_path(path) {
            let items = this.data;
            for (let i = 0; i < path.length; i += 2) {
                const item_index = path[i];
                items = items[item_index].children;
            }
            return items;
        },

        update_buttons() {
            this.update_back_button();
            this.update_next_button();
        },

        update_back_button() {
            const back_btn = document.getElementById('back-btn');
            if (this.current_path.length > 0) {
                back_btn.classList.remove('d-none');
            } else {
                back_btn.classList.add('d-none');
            }
        },

        setup_buttons() {
            // Back button
            document.getElementById('back-btn').addEventListener('click', () => {
                this.go_back();
            });

            // Next button
            document.getElementById('next-btn').addEventListener('click', () => {
                this.navigate_next();
            });

            // Update next button when radio selection changes
            document.addEventListener('change', (e) => {
                if (e.target.matches('input[name="option"]')) {
                    this.update_next_button();
                }
            });
        }
    };

    content_navigator.init();
});